export const NAME = 'courses';


// WEBPACK FOOTER //
// ./src/modules/courses/constants.js